import React from 'react';
import '../Styles/NoPage.css';

function NoPage() {
  return (
    <div className='Page'>
      {/* 404 PAGE NOT FOUND */}
    </div>
  )
}

export default NoPage